<template>
  <ais-refinement-list :attribute="attribute" :limit="limit">
    <template v-slot="{ items }">
      <dashboard-section :title="title" dataTestId="current-attribute-display" class="h-[420px]">
        <div class="flex-1 overflow-x-auto" data-testid="current-stage-cards-container">
          <data-table
            :value="getItems(items)"
            :rows="limit"
            tableStyle="w-full; border-spacing: 0 !important"
            :pt="myStudentsDataTableTheme"
          >
            <column field="label" :header="fieldLabel">
              <template #body="{data}">
                <router-link :to="listingLink(data, attribute)">
                  <span>{{ data.label }}</span>
                </router-link>
              </template>
            </column>
            <column field="count" :header="valueLabel">
              <template #body="{ data }">
                <progress-bar :maxValue="maxItemCount" :value="data.count" />
              </template>
            </column>
          </data-table>
        </div>
      </dashboard-section>
    </template>
  </ais-refinement-list>
</template>
<script setup>
import { computed, ref } from "vue";
import { RouterLink } from "vue-router";
import { AisRefinementList } from "vue-instantsearch/vue3/es";
import DataTable from "primevue/datatable";
import Column from "primevue/column";

import { myStudentsDataTableTheme } from "../primeVueTheme";
import { useNavigatingLinks } from "../composables/useNavigatingLinks";
import { useRegisteredFacets } from "../composables/useRegisteredFacets";
import DashboardSection from "./DashboardSection.vue";
import ProgressBar from "./ProgressBar.vue";

const props = defineProps({
  title: {
    type: String,
    default: "",
  },
  fieldLabel: {
    type: String,
    default: "Name",
  },
  valueLabel: {
    type: String,
    default: "Value",
  },
  attribute: {
    type: String,
    default: "",
  },
  limit: {
    type: Number,
    default: 5,
  },
  descending: {
    type: Boolean,
    default: true,
  },
  iconLookupFunction: {
    type: Function,
  },
});

const { currentFacets } = useRegisteredFacets();
const { listingLink } = useNavigatingLinks(currentFacets.value);

const maxItemCount = ref(0);

const getItems = computed(() => (items) => {
  const hasRefinements = items.some((item) => item.isRefined);
  maxItemCount.value = Math.max(...(items?.map((item) => item?.count ?? 0)?.concat([0]) ?? [0]));
  return items
    .filter((item) => !hasRefinements || (hasRefinements && item.isRefined))
    .sort((a, b) => {
      if (a.count !== b.count) {
        return props.descending ? b.count - a.count : a.count - b.count;
      }
      return a.label.localeCompare(b.label);
    })
    .slice(0, props.limit);
});
</script>
